/** UA Bot Console (Growth) — Overview/Forum/Interaction tab strings. Mirrors erp ubc_* keys. */
export const uaBotConsole: Record<string, string> = {
  'ubc.botStatus': 'Trạng thái Bot',
  'ubc.online': 'Đang hoạt động',
  'ubc.offline': 'Ngoại tuyến',
  'ubc.lastSeen': 'Lần cuối ghi nhận',
  'ubc.appsTracked': 'App theo dõi',
  'ubc.alertsToday': 'Cảnh báo hôm nay',
  'ubc.postsToday': 'Bài đăng hôm nay',
  'ubc.lastPostPerChannel': 'Bài đăng gần nhất theo kênh',
  'ubc.noPosts': 'Chưa có bài đăng nào.',
  'ubc.colChannel': 'Kênh',
  'ubc.colApp': 'App',
  'ubc.colPeriod': 'Kỳ',
  'ubc.colExcerpt': 'Trích đoạn',
  'ubc.recentTasks': 'Task sửa code gần đây',
  'ubc.accOffline': 'ACC ngoại tuyến — không tải được danh sách task.',
  'ubc.noTasks': 'Chưa có task nào.',
  'ubc.colTask': 'Task',
  'ubc.colStatus': 'Trạng thái',
  'ubc.forumFilterChannel': 'Lọc theo channel_id',
  'ubc.forumApply': 'Áp dụng',
  'ubc.forumEmpty': 'Chưa có bài đăng forum. Chỉ post forum per-app, forward-only — chỉ từ lúc bật logging.',
  'ubc.forumChannel': 'Kênh forum',
  'ubc.forumColLink': 'Liên kết',
  'ubc.forumOpen': 'Mở Discord',
  'ubc.forumNoLink': 'Không có liên kết',
  'ubc.chatPlaceholder': 'Mô tả thay đổi bạn muốn UA Bot thực hiện… (Ctrl+Enter để gửi)',
  'ubc.chatThinking': 'Đang xử lý…',
  'ubc.chatSend': 'Gửi',
  'ubc.proposalTitle': 'Đề xuất chỉnh sửa code',
  'ubc.proposalReason': 'Lý do',
  'ubc.proposalPurpose': 'Mục đích',
  'ubc.proposalFiles': 'Tệp ảnh hưởng',
  'ubc.proposalDiff': 'Diff dự kiến',
  'ubc.proposalApprove': 'Duyệt',
  'ubc.proposalReject': 'Từ chối',
  'ubc.gateStuck': 'Tạo task xong nhưng chưa mở cổng — bấm Duyệt lại để thử lại.',
  'ubc.taskQueued': 'Task đang chờ trong hàng đợi…',
  'ubc.taskRunning': 'Task đang chạy…',
  'ubc.taskDonePr': 'Hoàn tất — Pull Request:',
  'ubc.taskDoneNoPr': 'Task báo hoàn tất nhưng KHÔNG có Pull Request — cần kiểm tra lại (push bị bỏ qua).',
};
